<template>
    <div>
        <div class="bar"></div>
        <div class="navi">
            <div class="naviContent"><span style="cursor: pointer;">首页 </span>/ 用户反馈</div>
        </div>
       <div class="whiteContent" id="whiteContentId">
            <div class="whiteContent1" id="whiteContent1Id">
                <div class="whiteText">用户反馈</div>
                <textarea
                    v-model="contentDes"
                    id="textareaId"
                    class="contentText2"
                    @input="areaNumJudge"
                    placeholder="请告诉我们您对吉林一号遥感影像套件产品的意见和期许"
                ></textarea>
                <div class="textareaTip" id="textareaTipId">
                    内容描述输入限制为10~500个字符
                </div>
            </div> 
              <div class="whiteButton" @click="submitFeedback()">提交反馈</div>
       </div>
       <div class="shadow" v-if="isShadow==1">
            <div class="shadowContent1">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="$router.push('/MyRSservice');">
                <div class="shadowText3">您的反馈已提交</div>
                <div class="shadowButton" @click="$router.push('/MyRSservice');"> 关闭 ({{second}}s)</div>
            </div>
        </div>
       
    </div>
  </template>
  
  <script>
    import {rootUrl} from '@/globalConfig'

  export default {
    name: "Feedback",
    data() {
      return {
        contentDes: "",
        areaNum: false,
        isShadow:0,
        second: 5,
        timer:"",
      };
    },
    methods: {
        getKey() {
            return localStorage.getItem("token");
        },
        //实名权限检查与处理（遥感商城版）
        checkAndHandleAuthentication(){
          console.log("进入实名检查")
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(!loginUserId){
            this.jumpWithPermission('仅实名','/Login','/rskit/Feedback')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/rskit/Feedback')
          }
          return true;
        },
        //带权限判断的跳转
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        toPageTop(){
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        },
        getHeight(){
            let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
            let h = windowHeight - 236
            let whiteContentId = document.getElementById("whiteContentId")
            whiteContentId.style.height= h +"px"
            let whiteContent1Id = document.getElementById("whiteContent1Id")
            whiteContent1Id.style.height= h +"px"
            
        },
        areaNumJudge() {
            let contentDes = this.contentDes.length;
            let textareaId = document.getElementById("textareaId");
            let textareaTipId = document.getElementById("textareaTipId");
            if (contentDes < 10 || contentDes > 500) {
                textareaId.style.border = "1px solid #FF0000";
                textareaTipId.style.color = "#FF0000";
                this.areaNum = false;
            } else {
                textareaTipId.style.color = "#979797";
                textareaId.style.border = "1px solid rgba(0,0,0,0.1500)";
                this.areaNum = true;
            }
        },
        submitFeedback(){
            if(this.areaNum){
                var userInfo = {
                    content: this.contentDes
                };
                this.axios.post("/tilesapi/tiles/feedback/add",userInfo, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    this.isShadow=1
                    this.daojishiOn()
                })
            }
        },
        daojishiOn(){
            this.$nextTick(() => {
            this.timer = setInterval(this.daojishi, 1000);
        });
        },
        daojishi(){
            if(this.second<=0){
                this.$router.push("/MyRSservice");
                clearInterval(this.timer);
            }else{
                this.second--
            }
        },
    },
    mounted() {
      this.toPageTop()
      this.getHeight()
      this.checkAndHandleAuthentication()
    },
    computed: {
      
    },
  };
  </script>
  
  <style scoped>
    .bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.navi{
    position: relative;
    width: 100%;
    height: 40px;
    background: #F5F5F6;
}
.naviContent{
    position: absolute;
    width: 1920px;
    height: 40px;
    left: calc(50% - 960px);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 40px;
    padding-left: 120px;
}
.whiteContent{
    position: relative;
    left: calc(50% - 960px);
    width: 1920px;
    height: 1000px;
    background-color: #fff;
}
.whiteContent1{
    position: absolute;
    width: 1280px;
    height: 1000px;
    left: calc(50% - 640px);
}
.whiteText{
    position: absolute;
    top: 75px;
    left: calc(50% - 400px);
    width: 800px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.contentText2 {
  position: absolute;
  top: 167px;
  left: calc(50% - 540px);
  width: 1080px;
  height: 330px;
  background: #ffffff;
  border-radius: 4px;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding-top: 18px;
  padding-left: 16px;
  padding-right: 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
  line-height: 20px;
  resize: none;
}
.textareaTip {
  position: absolute;
  top:503px;
  left: 116px;
  width:300px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 17px;
}
.whiteButton{
    position: absolute;
    left: calc(50% - 28px);
    top: 599px;
    width: 150px;
height: 44px;
background: #0066CC;
border-radius: 8px;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 44px;
text-align: center;
cursor: pointer;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent1{
    position: fixed;
    top: calc(50% - 150px);
    left: calc(50% - 400px);
    width: 800px;
    height: 300px;
    background: #FFFFFF;
    border-radius: 12px;
}
.shadowClose{
position: absolute;
width: 40px;
height: 40px;
top: 0px;
right: -55px;
cursor: pointer;
}
.shadowText3{
    position: absolute;
    top: 100px;
    left: calc(50% - 400px);
    width: 800px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 25px;
    text-align: center;
}
.shadowButton{
    position: absolute;
    top: 175px;
    left: calc(50% - 75px);
    width: 150px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #3A3A3A;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 40px;
    text-align: center;
}
  </style>
  